module.exports = __webpack_public_path__ + "static/img/4.f7c50d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/4.jpg
// module id = 0xP9
// module chunks = 0